export default __webpack_public_path__ + "static/media/photo.1835b71e.png";